import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { userAtom } from "@Recoil/Atom/userAtom"
import { WorkShopService } from "@Services/Workshop.Service"
import React, { useEffect, useState } from "react"
import { ScrollView, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import styles from "./styles"
import * as Linking from "expo-linking"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { useRecoilValue } from "recoil"
import {
    UseParisDateTimeZone,
    dateTimeFormat,
    differenceBetweenToDateTime,
    fullName,
    isWithin48Hours
} from "@Utils/utils"
import moment from "moment"

const WorkshopDetails = () => {
    const route = useRoute()
    const [fetching, setFetching] = useState(true)
    const [joining, setJoining] = useState(false)
    const [update, setUpdate] = useState(false)
    const [alreadyMember, setAlreadyMember] = useState(false)
    const [workshop, setWorkshop] = useState([])
    const workshopId = route?.params?.workshopId ?? 0
    const sessionId = route?.params?.sessionId ?? 0
    const isVisio = route?.params?.isVisio ?? false
    const user = useRecoilValue(userAtom)
    const iframeData = workshop?.visioconference
    const navigation = useNavigation()

    const handleFetchWorkshop = () => {
        setFetching(true)
        WorkShopService.getWorkshopById(sessionId)
            .then((responses) => {
                const data = responses?.data?.data
                const invitedUser = data?.attendees?.map((item) => item?.attendeeUser?.id)
                setAlreadyMember(invitedUser?.includes(user?.id))
                setWorkshop(data)
                setFetching(false)
            })
            .catch(() => setFetching(false))
    }

    const joinRoom = () =>
        navigation.navigate("AppointmentVisioContent", {
            userDEUUID: workshop?.visioconference?.uniqid,
            isSimpleWorkshop: true
        })

    useEffect(() => {
        workshopId > 0 && handleFetchWorkshop()
    }, [workshopId, update])

    const openCallWithBrowser = () => {
        Linking.openURL(iframeData?.url).catch(() => {
            ShowToast({
                type: "error",
                message: "L'atelier en direct indisponible pour l'instant."
            })
        })
    }

    const handleJoinWorkshop = () => {
        setJoining(true)
        WorkShopService.joinWorkshop(workshopId, sessionId)
            .then(() => {
                ShowToast({
                    type: "success",
                    message: "Inscription à l'atelier réussie."
                })
                setUpdate((prev) => !prev)
                setJoining(false)
            })
            .catch(() => {
                ShowToast({
                    type: "error",
                    message: "Opération échouée."
                })
                setJoining(false)
            })
    }

    const intervenant = workshop?.attendees?.find((item) => item.attendeeType.id === 2)
    const intervenantName = fullName(intervenant?.attendeeUser?.lastName, intervenant?.attendeeUser?.firstName)
    const duration = differenceBetweenToDateTime(workshop.startDate, workshop.endDate)
    const enableVisioBtn = isWithin48Hours(workshop?.endDate, workshop?.startDate)
    const isVisioWorkshop = !workshop?.isInSitu

    return (
        <View style={styles.container}>
            {fetching ? (
                <ActivityIndicator color={baseColors.green.primary} size="large" style={{ padding: 30 }} />
            ) : (
                <>
                    <ScrollView contentContainerStyle={{ padding: 20, paddingBottom: 100 }}>
                        <View style={{ justifyContent: "center", alignItems: "center" }}>
                            <BreeSerifText style={{ fontSize: 25, color: baseColors.orange.primary }}>
                                {workshop?.summary}
                            </BreeSerifText>
                        </View>

                        <Spacer />
                        <OpenSansText style={{ fontSize: 16 }}>
                            Type d'atelier : {workshop?.consultationType?.name}
                        </OpenSansText>

                        <Spacer />
                        <OpenSansText style={{ fontSize: 16 }}>
                            Intervenant : {intervenantName ?? "---"}
                        </OpenSansText>

                        <Spacer />
                        <OpenSansText style={{ fontSize: 16 }}>
                            Durée : {duration} minutes
                        </OpenSansText>

                        <Spacer />
                        <OpenSansText style={{ fontSize: 16 }}>
                            Début : {UseParisDateTimeZone(workshop?.startDate, true).format(`dddd Do MMMM YYYY à HH:mm`)}
                        </OpenSansText>

                        <Spacer />
                        <OpenSansText style={{ fontSize: 16 }}>
                            Fin : {UseParisDateTimeZone(workshop?.endDate, true).format(`dddd Do MMMM YYYY à HH:mm`)}
                        </OpenSansText>

                        <Spacer />
                        {!isVisio && (
                            <>
                                <OpenSansText style={{ fontSize: 16 }}>
                                    Salle : {workshop?.location?.name}
                                </OpenSansText>
                                <Spacer />
                            </>
                        )}

                        <OpenSansText style={{ fontSize: 16 }}>
                            Description : {workshop?.description ?? workshop?.summary}
                        </OpenSansText>
                    </ScrollView>

                    <View
                        style={{
                            padding: 20,
                            backgroundColor: "white",
                            borderTopWidth: 1,
                            borderColor: "#eee"
                        }}
                    >
                        {alreadyMember ? (
                            isVisioWorkshop ? (
                                !enableVisioBtn ? (
                                    <OpenSansText
                                        style={{
                                            fontSize: 16,
                                            textAlign: "center",
                                            color: baseColors.orange.primary
                                        }}
                                    >
                                        L'atelier en direct est indisponible pour l'instant
                                    </OpenSansText>
                                ) : (
                                    <Button
                                        onPress={joinRoom}
                                        text={"Assister à l'atelier"}
                                        width="100%"
                                        backgroundColor={baseColors.orange.primary}
                                        labelColor={"white"}
                                    />
                                )
                            ) : null
                        ) : (
                            <Button
                                disabled={joining}
                                loading={joining}
                                onPress={handleJoinWorkshop}
                                text="S'inscrire à l'atelier"
                                width="100%"
                                backgroundColor={baseColors.orange.primary}
                                labelColor="white"
                            />
                        )}
                    </View>
                </>
            )}
        </View>
    )
}

export default WorkshopDetails
